var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvnstat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1999 8.09175V21.578C25.1999 23.7615 23.3799 25.4312 20.9999 25.4312H5.45972C5.45972 26.844 6.71973 28 8.25975 28H22.3999C25.4799 28 28 25.6881 28 22.8624V10.6606C28 9.24771 26.7399 8.09175 25.1999 8.09175Z",
    fill: "#037460"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.20004 0V2.56881H2.80003C1.26001 2.56881 0 3.72477 0 5.13761V20.5504C0 21.9633 1.26001 23.1193 2.80003 23.1193H19.8802C21.4202 23.1193 22.6802 21.9633 22.6802 20.5504V5.13761C22.6802 3.72477 21.4202 2.56881 19.8802 2.56881H18.4802V0H15.6802V2.56881H7.00007V0H4.20004ZM2.80003 8.99082H19.8802V20.5504H2.80003V8.99082Z",
    fill: "#037460"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.38 19.5227L13.02 17.7245L9.79997 19.5227L10.64 16.0548L7.69995 13.7429L11.62 13.486L13.16 10.1466L14.7 13.3576L18.6201 13.7429L15.68 16.0548L16.38 19.5227Z",
    fill: "#037460"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvnstat);
export default __webpack_public_path__ + "static/media/evnstat.a73a693016be07e787cf813e6c88467f.svg";
export { ForwardRef as ReactComponent };